export const addMinutes = (hhmm, min) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const tot = h * 60 + m + (parseInt(min) || 0);
  const norm = ((tot % 1440) + 1440) % 1440;
  const hh = Math.floor(norm / 60);
  const mm = norm % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
};

export const endTime = (t) => addMinutes(t.start_time, t.duration_min || 0);

export const interval = (t) => (t.start_time ? `${t.start_time}–${endTime(t)}` : "");

export const fmtDate = (d) => {
  if (!d) return "";
  const s = String(d).slice(0, 10);
  const [y, m, day] = s.split("-");
  return day && m && y ? `${day}-${m}-${y}` : s;
};

export const fmtDateTime = (d) => {
  if (!d) return "";
  let iso = String(d);
  if (!iso.includes("T")) return fmtDate(iso.slice(0, 10));
  // Se manca l'offset timezone, il timestamp è UTC (backend salva in UTC)
  const timePart = iso.slice(11);
  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(timePart)) iso += "Z";
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) {
    const date = fmtDate(String(d).slice(0, 10));
    const t = String(d).slice(11, 16);
    return t ? `${date} ${t}` : date;
  }
  const parts = new Intl.DateTimeFormat("it-IT", {
    timeZone: "Europe/Rome",
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(dt);
  const g = (type) => parts.find((p) => p.type === type)?.value || "";
  return `${g("day")}-${g("month")}-${g("year")} ${g("hour")}:${g("minute")}`;
};

export const appuntamento = (t) =>
  t.scheduled_date ? `${fmtDate(t.scheduled_date)} ${t.appointment_time || ""}`.trim() : "";
